import React from 'react';


const TableSpinner = ({ message = 'Loading…' }) => {

      return (
      <div className="flex flex-col items-center justify-center gap-3 rounded-2xl border border-primary-dark/20 bg-gray-50 py-12 text-primary-dark">
        <svg
          className="h-8 w-8 animate-spin text-primary-dark"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden
        >
          <path d="M21 12a9 9 0 1 1-6.219-8.56" />
        </svg>
        <span>{message}</span>
      </div>
    );
}

export default TableSpinner;